export default __webpack_public_path__ + "static/media/complementary--both-directions--g2.ab7a5976.png";